import type { ReactNode } from 'react'

// PageHeader — ATC-109 / `ATC-ADR-018`.
//
// The 24px/600 page title with an optional back link, subtitle and right-hand
// action cluster. ATC has three page shapes today (list, detail, feed) and each
// hand-rolls this; the primitive is where the fourth lands.
//
// The back link uses `--rx-accent-text` (#C2410C, 5.18:1), NOT `--rx-accent`
// (#F97316, 2.80:1) and not `--rx-accent-graphic` (#EA580C, 3.56:1). It is 13px
// body text, so it needs the 4.5:1 rung. This is the exact trap the four-slot
// split exists to prevent — see `ATC-ADR-018`.

export interface PageHeaderProps {
  title: ReactNode
  /**
   * A subtitle line — a customer name, a filter summary. For an identifier,
   * pass a `<Mono>`; for an absent value, say so in words rather than with an
   * em-dash.
   */
  subtitle?: ReactNode
  /**
   * Back navigation. Rendered above the title. Pass a `<Link>` — the primitive
   * does not import the router, so it stays usable outside a route.
   */
  back?: ReactNode
  /** Right-aligned controls. */
  actions?: ReactNode
}

export function PageHeader({ title, subtitle, back, actions }: PageHeaderProps) {
  return (
    <div className="rx-page-header">
      <div className="rx-page-header-text">
        {back}
        <h1 className="rx-page-title">{title}</h1>
        {subtitle !== undefined && <div className="rx-page-subtitle">{subtitle}</div>}
      </div>
      {actions !== undefined && <div className="rx-page-header-actions">{actions}</div>}
    </div>
  )
}
